export enum OptInOptOutStatus {
  NotAsked = 'NotAsked',
  OptIn = 'OptIn',
  OptOut = 'OptOut'
}
